@if (authenticated) {
  <div class="gung-app-navbar navbar" [style.height.px]="navbarHeight + (isCarOLiner ? 16 : 0)">
    @if (!!navbarBanner && navbarBanner?.enabled) {
      <div [style.height.px]="navbarBanner.bannerHeight">
        <div
          class="navbar-banner"
          [style.height.px]="navbarBanner.bannerHeight"
          [style.backgroundColor]="navbarBanner.backgroundColor"
          [style.color]="navbarBanner.textColor"
          [ngClass]="{
            'justify-content-center': navbarBanner.centerText,
            'fw-bold': navbarBanner.textFormatting === 'bold',
            'fst-italic': navbarBanner.textFormatting === 'italic',
            'text-decoration-underline': navbarBanner.textFormatting === 'link',
          }"
          [style.backgroundImage]="'url(&quot;' + getBannerImageUrl() + '&quot;)'"
        >
          {{navbarBanner.text}}
        </div>
      </div>
    }
    <div class="navbar-top">
      <div class="left-top-navbar align-items-center">
        @if (showflowMenu && !forceToNotShowFlowsOnTop) {
          <div class="navbar-nav desktop-flow-menu">
            <ng-container *ngTemplateOutlet="flowMenu"></ng-container>
          </div>
        }
        @if (gungNavbar.showNavbarSearch) {
        <div class="global-search-desktop w-75 mr-4" style="max-width: 450px;">
          @if (baseViewConfigService.enableClerkSearch) {
            <lib-clerk-global-search></lib-clerk-global-search>
          } @else {
            <lib-global-search></lib-global-search>
          }
        </div>
        }

      </div>

      <div class="logo">
        <div class="nav-brand-wrapper d-flex">
          <a class="navbar-brand" routerLink="/home">
            <img src="{{ logoUrl }}" width="auto" [style.height.px]="isCarOLiner ? 52 : 36" alt="Logotype" />
          </a>

        </div>
      </div>

      <div class="navbar-right d-flex align-items-center">
        @if (!isAnonymous && authenticated) {
          <div class="icons d-flex align-items-center">
            @if (gungNavbar.showNavbarSearch) {
            <div class="mobile-search icon-action">
              <span>
                <i class="fa-solid fa-magnifying-glass" (click)="isGlobalSearchOpen = !isGlobalSearchOpen"></i>
                <span class="icon-label">{{ 'SEARCH' | translate }}</span>
              </span>
              @if (isGlobalSearchOpen) {
                <div class="mobile-search-container">
                  @if (baseViewConfigService.enableClerkSearch) {
                    <lib-clerk-global-search></lib-clerk-global-search>
                  } @else {
                    <lib-global-search [roundedCorners]="true"></lib-global-search>
                  }
                </div>
              }
            </div>
            }
            <div class="icon-action" *ngIf="isSales && !mobileDevice && !hideMyCustomers">
              <a [routerLink]="['/customers']">
                <i class="fa-solid fa-users" title="{{ 'CUSTOMERS' | translate }}"></i>
                <span class="icon-label">{{ 'MY_CUSTOMERS' | translate }}</span>
              </a>
            </div>
            <div class="icon-action" *ngIf="!mobileDevice && !hideFavorites">
              <a [routerLink]="['/favourites']">
                <span class="icon-wrap">
                  <i class="fa-solid fa-heart" title="{{ 'FAVOURITES' | translate }}"></i>
                  @if (favouritesCount > 0) {
                    <span class="badge badge-primary rounded-circle cart-icon-badge text-white">{{ favouritesCount }}</span>
                  }
                </span>
                <span class="icon-label">{{ 'FAVOURITES' | translate }}</span>
              </a>
            </div>
            <div class="icon-action" *ngIf="isUser && moreThanOneCustomer">
              <a [routerLink]="['/delivery-location']">
                <i class="fa-solid fa-arrow-right-arrow-left" title="{{ 'CHANGE_ACCOUNT' | translate }}"></i>
                <span class="icon-label">{{ 'CHANGE_ACCOUNT' | translate }}</span>
              </a>
            </div>
            <div class="icon-action" *ngIf="isUser">
              <a (click)="logout()">
                <i class="fa-solid fa-arrow-right-from-bracket" title="{{ 'LOGOUT' | translate }}"></i>
                <span class="icon-label">{{ 'LOGOUT' | translate }}</span>
              </a>
            </div>
            <div *ngIf="!hideCart" class="icon-action icon-checkout" #iconCheckoutElement>
              <a [routerLink]="['/checkout']">
                <span class="icon-wrap">
                  <i class="fa-solid fa-cart-shopping"></i>
                  @if (!!cartContents) {
                    <span class="badge badge-primary rounded-circle cart-icon-badge text-white">{{ cartContents.rows.length }}</span>
                  }
                </span>
                <span class="icon-label">{{ 'CART' | translate }}</span>
              </a>
              <div class="navbar-cart" [class.d-none]="!!hideCartDropdown">
                <ng-template #navbarCart></ng-template>
              </div>
            </div>
          </div>
        }@else{
          <div class="icons d-flex align-items-center">
            <div class="icon-action">
              <a [routerLink]="['/login']">
                <i class="fa-solid fa-user" title="{{ 'LOGIN' | translate }}"></i>
                <span class="icon-label">{{ 'LOGIN' | translate }}</span>
              </a>
            </div>
          </div>
        }
      </div>
    </div>
    @if (showflowMenu && !forceToNotShowFlowsOnTop) {
      <div class="mobile-flow-menu">
        <div class="navbar-nav ">
          <ng-container *ngTemplateOutlet="flowMenu"></ng-container>
        </div>
      </div>
    }
    <div class="navbar-nav">
      <div class="shop-menu d-flex align-items-center">
        @for (menu of (mobileDevice && shopMenu?.length > 2 ? mobileShopMenu : shopMenu); track menu) {
          <div class="s-menu flex-row d-flex align-items-center" [class.active]="menu.heading === 'NEW_PRODUCTS' && currentUrl?.includes('SHOW_NEW_PRODUCTS')" [routerLinkActive]="menu.link ? ['active'] : []" [routerLinkActiveOptions]="{ exact: false }" (mouseenter)="menu.links?.length ? onSMenuEnter($event) : null">
            <div class="menu-name" translate>
              <a
                [routerLink]="menu.link ? [menu.link] : null"
                [queryParams]="menu.queryParams ?? null"
                (click)="menu.action ? menu.action() : null"
                [routerLinkActive]="menu.link ? 'active' : ''"
                [class.active]="(!menu.link && selectedFlow?.name?.toLowerCase() === menu.heading?.toLowerCase()) || (menu.heading === 'NEW_PRODUCTS' && currentUrl?.includes('SHOW_NEW_PRODUCTS'))"
              >
                {{ menu.heading | translate }}
              </a>
            </div>
            @if (menu.links && menu.links.length > 0) {
              <i class="fa-solid fa-chevron-down ml-2 pr-1"></i>
              @if (!isClosingShowMenu) {
                <div class="sub-menu" [class.d-none]="isClosingShowMenu">
                  <lib-gung-expand-menu
                    (closeExpandMenu)="closeExpandMenu($event)"
                    [menu]="menu.links"
                    [levels]="(mobileDevice && shopMenu?.length > 2) ? +gungNavbar.assortmentMenuLevel + 1 : +gungNavbar.assortmentMenuLevel"
                    [mobileDevice]="mobileDevice"
                    top="30"
                    left="0"
                  />
                </div>
              }
            }
          </div>
        }
      </div>
      <div class="nav-info">
        @if (!isAnonymous && authenticated) {
          @if (customerInfo && !hideSelectedCustomer) {
            <div class="customer ml-2">
              @if (!isUser) {
                <a [routerLink]="['/customers', customerInfo.id]">
                  {{ customerInfo.description }}
                </a>
              } @else {
                {{ customerInfo.description }}
              }
            </div>
          }
          <div class="icon-action btn-open-menu" (click)="toggleMainMenu()" (keyup.enter)="toggleMainMenu()" tabindex="0"><i class="fa-solid fa-bars"></i></div>
        }
      </div>
    </div>
  </div>
  <div class="main-menu" [class.menu-open]="activeMainMenu" [style.top.px]="navbarHeight + (isCarOLiner ? 16 : 0)">
    <lib-gung-main-menu (menuClickEvent)="menuClickEvent($event)"></lib-gung-main-menu>
  </div>
  <div class="content-margin" [style.height.px]="navbarHeight + (isCarOLiner ? 16 : 0)"></div>
}

<ng-template #flowMenu>
  <div class="flow-menu">
    @if (flowsMenu.length > 2) {
      <div class="s-menu flex-row d-flex align-items-center p-2">
        <div class="menu-name" translate>
          <span class="flow-name">{{ selectedFlow.name }}</span>
        </div>
        <i class="fa-solid fa-chevron-down ml-2 pr-1"></i>
        @if (!isClosingShowMenu) {
          <div class="sub-menu" [class.d-none]="isClosingShowMenu">
            <lib-gung-expand-menu
              (closeExpandMenu)="closeExpandMenu($event)"
              [menu]="flowsMenu"
              [mobileDevice]="mobileDevice"
              top="32"
              left="0"
            />
          </div>
        }
      </div>
    } @else {
      @for (menu of flowsMenu; track menu) {
        <div class="s-menu flex-row d-flex align-items-center">
          <div class="menu-name" translate>
            <a [routerLink]="menu.link ? [menu.link] : null" [class.active]="selectedFlow.name === menu.heading" (click)="menu.action ? menu.action() : null">{{
              menu.heading | translate
            }}</a>
          </div>
        </div>
      }
    }
  </div>
</ng-template>
